import mixpanel from 'mixpanel-browser';

const source = 'dashboard:cloud';

export default {
    trackClickedWord() {
        mixpanel.track(`${source}:keyword_clicked`);
    },

    trackSentimentSelection(clickedSentiment) {
        const sentiments = ['Negative', 'Positive', 'Neutral'];

        const selectedSentiments = sentiments.find(sentiment => sentiment === clickedSentiment);
        mixpanel.track(`${source}:sentiment_selected`, {
            'Sentiment Enabled': selectedSentiments
        });
    }
};
